"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var QuestionMarkIcon = function QuestionMarkIcon(props) {
  var _React$createElement;

  return _react["default"].createElement("svg", (_React$createElement = {
    width: props.width,
    height: props.height,
    viewBox: "0 0 22 22",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _React$createElement["xmlns"] = "http://www.w3.org/1999/xlink", _React$createElement), _react["default"].createElement("title", null, "Tooltip"), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M11,1 C5.48,1 1,5.48 1,11 C1,16.52 5.48,21 11,21 C16.52,21 21,16.52 21,11 C21,5.48 16.52,1 11,1 Z M12,18 L10,18 L10,16 L12,16 L12,18 Z M14.07,10.25 L13.17,11.17 C12.45,11.9 12,12.5 12,14 L10,14 L10,13.5 C10,12.4 10.45,11.4 11.17,10.67 L12.41,9.41 C12.78,9.05 13,8.55 13,8 C13,6.9 12.1,6 11,6 C9.9,6 9,6.9 9,8 L7,8 C7,5.79 8.79,4 11,4 C13.21,4 15,5.79 15,8 C15,8.88 14.64,9.68 14.07,10.25 Z",
    fill: props.colour || "#FFFFFF",
    fillRule: "nonzero"
  })));
};

var _default = QuestionMarkIcon;
exports["default"] = _default;